<project-details-breadcrumb-header *ngIf="status == STATUS_DONE || status == STATUS_GROUP_TAGS_NOT_ALLOWED"
  [project]="project"
  [title]="breadcrumbTitle"
  [breadcrumbs]="breadcrumbs"
></project-details-breadcrumb-header>
  <div class="loader" [hidden]="status != STATUS_LOADING">
    <div class="dimmed dimmed_top">
      <div class="dimmed_content">
        <div class="dimmed_title"></div>
        <div class="dimmed_title"></div>
        <div class="dimmed_flex">
          <span class="dimmed_tag"></span>
          <span class="dimmed_tag"></span>
          <span class="dimmed_tag"></span>
        </div>
      </div>
    </div>
  </div>
<div *ngIf="status == STATUS_GROUP_TAGS_NOT_ALLOWED" class="alert-version">
  <core-helpers-box-alert-message-icon 
    [text]="'Incorrect Project tags - You can not upload this group artwork to this project.'"
    [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
</div>
<div *ngIf="status == STATUS_DONE">
    <versions-add-main
      [project]="project"
      [labels]="labels"
      [editTagsAccess]="editVersionTagsAccess"
      [versionNumber]="versionNumber"
    ></versions-add-main>
</div>
<core-helpers-box-http-error
  *ngIf="status == STATUS_NOT_ALLOWED"
  [code]="403"
  [message]="'Not allowed.'"
></core-helpers-box-http-error>
